import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@material-ui/core';
import styles from './CarryForwardModal.module.css';

const CarryForwardModal = ({
  open,
  handleClose,
  rowsData,
  asnCarryForwardCount,
  handleSubmit,
  cancelButtonText = 'Cancel',
  submitButtonText = 'Confirm',
}) => {
  console.log("rowsdata:", rowsData)
  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div className={styles.formContainer}>
          <div className={styles.formTitle}>
            <div>
              <span>{asnCarryForwardCount}</span>
              <span>ASN are selected for Carry forward</span>
            </div>
          </div>
          <div className={styles.subHeading}>
            Are you sure you want to carry forward the ASN.
            <br /> Once done you will not be able to revert back.
          </div>

          <div className={styles.bottomRow}>
            <button className={styles.cancelBt} onClick={handleClose}>
              {cancelButtonText}
            </button>
            <span>
              <button
                onClick={() => {
                  handleSubmit(rowsData);
                  handleClose();
                }}
                className={styles.submitBt}
              >
                {submitButtonText}
              </button>
            </span>
          </div>
        </div>
      </Modal>
    </>
  );
};

CarryForwardModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  rowsData: PropTypes.arrayOf(
    PropTypes.shape({
      vc: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      market: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired,
      count: PropTypes.string.isRequired,
      fbv: PropTypes.string.isRequired,
    }),
  ),
  asnCarryForwardCount: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
};

export default CarryForwardModal;
